import { render, staticRenderFns } from "./RecipientList.vue?vue&type=template&id=715ce807&scoped=true&lang=html"
import script from "./RecipientList.vue?vue&type=script&lang=js"
export * from "./RecipientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ce807",
  null
  
)

export default component.exports